import * as constants from './constants';
import { guardNullOrUndefined } from '../utils/guards';

export const suscribeUser = subscription => {
  guardNullOrUndefined(subscription);
  return { type: constants.SUSCRIPTION_USER, subscription };
};

export const suscribeUserSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.SUSCRIPTION_USER_SUCCESS, data };
};

export const suscribeUserFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.SUSCRIPTION_USER_FAILED, error };
};

export const updateUserSubscription = data => {
  guardNullOrUndefined(data);
  return { type: constants.UPDATE_USER_SUBSCRIPTION, data };
};

export const updateUserSubscriptionSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.UPDATE_USER_SUBSCRIPTION_SUCCESS, data };
};

export const restoreUserSubscription = data => {
  guardNullOrUndefined(data);
  return { type: constants.RESTORE_USER_SUBSCRIPTION, data };
};

export const restoreUserSubscriptionSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.RESTORE_USER_SUBSCRIPTION_SUCCESS, data };
};

export const restoreUserSubscriptionFailed = data => {
  guardNullOrUndefined(data);
  return { type: constants.RESTORE_USER_SUBSCRIPTION_FAILED, data };
};

export const saveSearch = () => ({ type: constants.SAVE_NOTIFICATION_SEARCH });

export const saveSearchSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.SAVE_NOTIFICATION_SEARCH_SUCCESS, data };
};

export const saveSearchFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.SAVE_NOTIFICATION_SEARCH_FAILED, error };
};

export const fetchSearches = subscriptionId => {
  guardNullOrUndefined(subscriptionId);
  return { type: constants.FETCH_NOTIFICATION_SEARCHES, subscriptionId };
};

export const fetchSearchesSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.FETCH_NOTIFICATION_SEARCHES_SUCCESS, data };
};

export const fetchSearchesFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.FETCH_NOTIFICATION_SEARCHES_FAILED, error };
};

export const updateSearch = (searchId, isActive) => {
  guardNullOrUndefined(searchId);
  return { type: constants.UPDATE_NOTIFICATION_SEARCH, searchId, isActive };
};

export const updateSearchSuccess = data => {
  guardNullOrUndefined(data);
  return { type: constants.UPDATE_NOTIFICATION_SEARCH_SUCCESS, data };
};

export const updateSearchFailed = error => {
  guardNullOrUndefined(error);
  return { type: constants.UPDATE_NOTIFICATION_SEARCH_FAILED, error };
};

export const setSubscriptionId = data => {
  guardNullOrUndefined(data);
  return { type: constants.SET_NOTIFICATION_SUBSCRIPTIONID, data };
};

export const resetUserSubscription = () => ({ type: constants.RESET_USER_SUBSCRIPTION });

export const userHasDisallowPush = () => ({ type: constants.SUSCRIPTION_USER_HAS_DISALLOW_PUSH });



// WEBPACK FOOTER //
// ./app/Notifications/actions.js